// Run this example by adding <%= javascript_pack_tag 'hello_react' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. All it does is render <div>Hello React</div> at the bottom
// of the page.

import React from 'react';
import { Menu } from '@material-ui/icons';
import StarIcon from '@material-ui/icons/Star';

import './PageSubNav.css';

class PageSubnav extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          isLinksVisible: false
        }
    }

    renderNavLinks = () => {
        const { typeOfListing, handleClick, links } = this.props;
        
        return (
            <ul className="nav navbar-nav">
                {links.map((link, index) => (

                    <React.Fragment key={index}>
                        <li
                        className={
                            (link.toLowerCase().replace(/\s/g, '') === typeOfListing) || (link.toLowerCase().replace(/\s/g, '') === 'galleries&videos' && typeOfListing === 'fanzone')
                                ? `active nav-item &#147;false ${typeOfListing}`
                                : 'nav-item &#147;false'
                        }
                        >
                            <a
                                key={index}
                                href="/"
                                data-index="0"
                                onClick={handleClick}
                            >
                                {(link.toLowerCase().replace(/\s/g, '') === typeOfListing) || (link.toLowerCase().replace(/\s/g, '') === 'galleries&videos' && typeOfListing === 'fanzone') ? <StarIcon /> : null}
                                {link}
                            </a>
                        </li>
                    </React.Fragment>
                ))}
            </ul>
        );
    };
    toggleLinks = () => {
      this.setState({
        isLinksVisible: !this.state.isLinksVisible
      })
    }
    render() {
        let linksClassName = "collapse navbar-collapse"
        if (this.state.isLinksVisible) linksClassName += " in"
        return (
            <div className="content white page-sub-nav">
                <div className="container">
                    <div className="page-subnav-container">
                        <nav
                            className="center navbar page-subnav"
                            role="navigation"
                        >
                            <div className="navbar-header">
                                <button
                                    className="collapsed navbar-toggle"
                                    data-toggle="collapse"
                                    data-target="#page-subnav"
                                    onClick={this.toggleLinks}
                                >
                                    <Menu fontSize="inherit" />
                                </button>
                            </div>
                            <div
                                className={linksClassName}
                                id="page-subnav"
                            >
                                {this.renderNavLinks()}
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        );
    }
}
export default PageSubnav;
